export const Tile6 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 15 16"
      shape-rendering="crispEdges"
    >
      <metadata>
        Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj
      </metadata>
      <path
        stroke="#222428"
        d="M0 0h1M1 1h3M2 5h1M5 5h5M2 6h1M2 7h1M2 8h1M2 9h1M5 9h4M2 10h1M8 10h1M2 11h1M13 11h1M2 12h2M13 12h1M3 13h6M13 13h1M8 15h1M10 15h2"
      />
      <path
        stroke="#333436"
        d="M1 0h1M0 1h1M1 2h12M1 3h3M11 3h2M1 4h2M11 4h2M1 5h1M10 5h3M1 6h1M5 6h8M1 7h1M10 7h3M1 8h1M11 8h2M1 9h1M11 9h2M1 10h1M5 10h3M11 10h2M1 11h1M11 11h2M1 12h1M10 12h3M1 13h2M9 13h4M12 14h2M12 15h2"
      />
      <path stroke="#3d3e40" d="M2 0h1M0 2h1M0 3h1M0 4h1M9 14h3M14 15h1" />
      <path
        stroke="#4b4c4e"
        d="M3 0h2M0 5h1M0 6h1M0 7h1M0 8h1M0 9h1M14 13h1M5 14h4M14 14h1"
      />
      <path stroke="#616266" d="M5 0h2M14 11h1M14 12h1" />
      <path
        stroke="#727377"
        d="M7 0h8M14 1h1M14 2h1M14 3h1M14 4h1M14 5h1M14 6h1M14 7h1M14 8h1M14 9h1M0 10h1M14 10h1M0 11h1M0 12h1M0 13h1M0 14h5"
      />
      <path
        stroke="#16181e"
        d="M4 1h10M13 2h1M13 3h1M13 4h1M13 5h1M13 6h1M13 7h1M13 8h1M13 9h1M13 10h1M0 15h8M9 15h1"
      />
      <path
        stroke="#e96113"
        d="M4 3h7M3 4h8M3 5h2M3 6h2M3 7h7M3 8h8M3 9h2M9 9h2M3 10h2M9 10h2M3 11h8M4 12h6"
      />
    </svg>
  );
};
